"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconChevronDownOutline = _interopRequireDefault(require("./IconChevronDownOutline"));
var IconChevronRightOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconChevronDownOutline.default).withConfig({
  displayName: "IconChevronRightOutline",
  componentId: "c11n-8-107-0__sc-1yzayyv-0"
})(["transform:rotate(270deg);"]);
var _default = IconChevronRightOutline;
exports.default = _default;